/** 波速与波传播参数（与 backend/internal/pipeline/inversion 保持一致） */
export const P_WAVE_KM_S = 6.0
export const S_WAVE_KM_S = 3.5

/** 传播环最大半径（km）：覆盖整个演示区域后停止动画 */
export const WAVE_MAX_RADIUS_KM = 1200

/** 演示区域主要城市（新疆，与地图默认中心一致） */
export const CITIES: Array<{ name: string; lat: number; lon: number }> = [
  { name: '乌鲁木齐', lat: 43.8256, lon: 87.6168 },
  { name: '昌吉', lat: 44.0146, lon: 87.3082 },
  { name: '石河子', lat: 44.3061, lon: 86.0806 },
  { name: '奎屯', lat: 44.4244, lon: 84.9022 },
  { name: '克拉玛依', lat: 45.5889, lon: 84.8892 },
  { name: '伊宁', lat: 43.9167, lon: 81.3167 },
  { name: '塔城', lat: 46.7487, lon: 82.9803 },
  { name: '吐鲁番', lat: 42.9697, lon: 89.1864 },
  { name: '哈密', lat: 42.8189, lon: 93.5151 },
  { name: '库尔勒', lat: 41.7661, lon: 86.1414 },
  { name: '阿克苏', lat: 41.1672, lon: 80.2639 },
  { name: '喀什', lat: 39.4704, lon: 75.9897 },
]

/** CAV（累计绝对速度）→ 脉冲尺寸，对数压缩避免强触发淹没弱触发 */
export function triggerPulseSize(cav: number): number {
  return Math.max(16, Math.min(56, 16 + Math.log1p(Math.max(0, cav)) * 7))
}

/** CAV → 强度条宽度百分比（0-100），对数尺度 */
export function triggerStrengthPercent(cav: number): number {
  return Math.min(100, (Math.log1p(Math.max(0, cav)) / Math.log1p(300)) * 100)
}
